import clsx from "clsx";
import { FeaturedIcon } from "../../Icon";
import DefaultImage from "../../../../assets/Images/BrandImage1.png";

type Props = {
  magnetName: string;
  brandName?: string;
  info?: any;
  imageUrl: string;
  additionalClasses?: string;
  isFeatured?: boolean;
  isMemento?: boolean;
};

interface ClickableCard extends Props {
  isClickable: boolean;
  handleOnClick: () => void;
}
interface ViewOnlyCard extends Props {
  isClickable?: never;
  handleOnClick?: never;
}

function UserMagnetCard({
  magnetName,
  info,
  imageUrl,
  brandName,
  additionalClasses = "",
  isFeatured,
  isClickable = false,
  handleOnClick,
}: ClickableCard | ViewOnlyCard) {
  return (
    <div className={clsx(isClickable && "cursor-pointer", "max-w-[180px]")} onClick={handleOnClick}>
      <div className="relative">
        {/* Info About activity if it is present */}
        {info && (
          <div
            className="absolute
          -right-2 -top-2 z-10 rounded-full bg-accent px-2 py-0.5"
          >
            {info}
          </div>
        )}
        <div className="aspect-h-1 aspect-w-1">
          <img
            src={imageUrl || DefaultImage}
            alt={magnetName}
            className="h-full w-full rounded-2xl border-1 border-white border-opacity-10  object-cover"
          />
        </div>
        {/* Mark the card if it is featured */}
        {isFeatured && (
          <div
            className="absolute bottom-0 right-0 rounded-bl-md
           rounded-br-2xl rounded-tl-lg rounded-tr-md bg-primary bg-opacity-70 p-1"
          >
            <FeaturedIcon width="20" height="20" />
          </div>
        )}
      </div>
      <p
        className={clsx(
          "mt-0.5 truncate text-left font-satoshi text-xxs  md:text-xs lg:text-sm ",
          " font-semibold leading-7 text-white first-letter:uppercase 2xl:mt-1 2xl:text-lg",
          additionalClasses,
        )}
      >
        {magnetName}
      </p>
      {brandName && (
        <p
          className="mt-0.5 text-left font-satoshi text-base   font-semibold text-white text-opacity-50
          md:text-xxs lg:text-xs 2xl:mt-1 "
        >
          {brandName}
        </p>
      )}
    </div>
  );
}
export default UserMagnetCard;
